module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="icon-header '+
((__t=( icon ))==null?'':__t)+
'">'+
((__t=( i18n.tc("EditCustomer", "Billing account") ))==null?'':__t)+
'</h4><fieldset><dl><dt class="label">'+
((__t=( i18n.tc("EditCustomer", "Customer number:") ))==null?'':__t)+
'</dt><dd class="input">'+
((__t=( id ))==null?'':__t)+
'</dd></dl></fieldset><fieldset><div class="type-private-only"><legend>'+
((__t=( i18n.tc("EditCustomer", "Personalia") ))==null?'':__t)+
'</legend><div><label for="customer-first-name-input">'+
((__t=( i18n.tc("EditCustomer", "First name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-first-name-input" data-input="customer-first-name" value="'+
((__t=( firstName ))==null?'':__t)+
'" required></div><div><label for="customer-last-name-input">'+
((__t=( i18n.tc("EditCustomer", "Last name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-last-name-input" data-input="customer-last-name" value="'+
((__t=( lastName ))==null?'':__t)+
'" required></div></div><div class="type-company-only"><legend>'+
((__t=( i18n.tc("EditCustomer", "Company details") ))==null?'':__t)+
'</legend><div><label for="customer-company-name-input">'+
((__t=( i18n.tc("EditCustomer", "Company name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-company-name-input" data-input="customer-company-name" value="'+
((__t=( companyName ))==null?'':__t)+
'"></div><div><label for="customer-company-number-input">'+
((__t=( i18n.tc("EditCustomer", "Company number:") ))==null?'':__t)+
'</label> <input type="text" id="customer-company-number-input" data-input="customer-company-number" value="'+
((__t=( companyNumber ))==null?'':__t)+
'"></div></div></fieldset><fieldset class="type-private-only"><div><label for="customer-birth-date">'+
((__t=( i18n.tc("CreateCustomer", "Date of birth:") ))==null?'':__t)+
'</label><div class="input"><select id="customer-birth-date" class="col-3" data-input="customer-birth-date-day"><option value="">'+
((__t=( i18n.tc("EditCustomer", "Day") ))==null?'':__t)+
'</option></select> <select class="col-3" data-input="customer-birth-date-month"><option value="">'+
((__t=( i18n.tc("EditCustomer", "Month") ))==null?'':__t)+
'</option></select> <select class="col-3" data-input="customer-birth-date-year"><option value="">'+
((__t=( i18n.tc("EditCustomer", "Year") ))==null?'':__t)+
'</option></select></div></div></fieldset><fieldset><legend>'+
((__t=( i18n.tc("EditCustomer", "Contact information") ))==null?'':__t)+
'</legend><div><label for="customer-contact-mail-input">'+
((__t=( i18n.tc("EditCustomer", "Contact email:") ))==null?'':__t)+
'</label> <input type="text" id="customer-contact-mail-input" data-input="customer-contact-mail" value="'+
((__t=( contactEmail ))==null?'':__t)+
'" required></div></fieldset><fieldset><div><label for="customer-address-1">'+
((__t=( i18n.tc("EditCustomer", "Address 1:") ))==null?'':__t)+
'</label> <input type="text" id="customer-address-1" data-input="customer-address-1" value="'+
((__t=( address1 ))==null?'':__t)+
'" required></div><div><label for="customer-address-2">'+
((__t=( i18n.tc("EditCustomer", "Address 2:") ))==null?'':__t)+
'</label> <input type="text" id="customer-address-2" data-input="customer-address-2" value="'+
((__t=( address2 ))==null?'':__t)+
'"></div><div class="clearfix"><div class="narrow"><label for="customer-postcode-input">'+
((__t=( i18n.tc("EditCustomer", "Post code:") ))==null?'':__t)+
'</label> <input type="text" id="customer-postcode-input" data-input="customer-postcode" value="'+
((__t=( postcode ))==null?'':__t)+
'" required></div><div class="wide"><label for="customer-city-input">'+
((__t=( i18n.tc("EditCustomer", "City:") ))==null?'':__t)+
'</label> <input type="text" id="customer-city-input" data-input="customer-city" value="'+
((__t=( city ))==null?'':__t)+
'" required></div></div><div><label for="customer-country-input">'+
((__t=( i18n.tc("EditCustomer", "Country:") ))==null?'':__t)+
'</label> <select id="customer-country-input" data-input="customer-country"><option value="">'+
((__t=( i18n.tc("EditCustomer", "Choose a country") ))==null?'':__t)+
'</option></select></div></fieldset><fieldset><legend>'+
((__t=( i18n.tc("EditCustomer", "Invoice options") ))==null?'':__t)+
'</legend><div><p class="label">'+
((__t=( i18n.tc("EditCustomer", "Invoice:") ))==null?'':__t)+
'</p><div class="input" data-container="checkbox-array"><div><input type="radio" id="customer-invoice-email-input" name="customer-invoice-input" data-input="customer-invoice-email" value="EMAIL" '+
((__t=( ( _.contains( invoiceTypes, "EMAIL" ) ) ? " checked" : ""  ))==null?'':__t)+
'> <label class="align-left" for="customer-invoice-email-input">'+
((__t=( i18n.tc("EditCustomer", "Email") ))==null?'':__t)+
'</label></div><div><input type="radio" id="customer-invoice-paper-input" name="customer-invoice-input" data-input="customer-invoice-paper" value="PAPER" '+
((__t=( ( _.contains( invoiceTypes, "PAPER" ) ) ? " checked" : ""  ))==null?'':__t)+
'> <label class="align-left" for="customer-invoice-paper-input">'+
((__t=( i18n.tc("EditCustomer", "Paper mail") ))==null?'':__t)+
'</label></div></div></div><div class="invoice-email-only"><label for="customer-invoice-email-address-input">'+
((__t=( i18n.tc("EditCustomer", "Invoice email:") ))==null?'':__t)+
'</label> <input type="text" id="customer-invoice-email-address-input" data-input="customer-invoice-email-address" value="'+
((__t=( invoiceEmail ))==null?'':__t)+
'" required></div></fieldset><fieldset class="button-wrap"> ';
 if ( isCustomerMe ) { 
__p+=' <button data-click="customer-customers">'+
((__t=( i18n.tc("EditCustomer", "My billing accounts") ))==null?'':__t)+
'</button> ';
 } 
__p+=' <button class="primary" data-click="customer-submit" disabled="disabled">'+
((__t=( i18n.tc("EditCustomer", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
